import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateService, TranslateModule } from '@ngx-translate/core';

import type { ICellRendererAngularComp } from 'ag-grid-angular';
import type { ICellRendererParams } from 'ag-grid-community';
import { BrokerAssociationStatus } from '../../broker.models';
import { NgClass } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'app-status-renderer',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIconModule,NgClass, TranslateModule, MatTooltipModule],
    standalone: true,
    template: `
        <span>
            @if (value()) {
                <mat-icon [ngClass]="{'red': isRed}" [attr.aria-label]="translateService.instant(tooltip())" [matTooltip]="translateService.instant(tooltip())" > {{value()}}</mat-icon>
            }
        </span>
    `,
    styles: [
        `mat-icon {
            font-size: 20px;
        }
        .red {
            color:#cb1517;
        }
        span {display: flex; height: 100%; justify-content: center; align-items: center}
        `,
    ],
})
export class StatusRendererComponent implements ICellRendererAngularComp {
    value = signal<string | undefined>(undefined);
    tooltip = signal<string | undefined>(undefined);
    isRed:boolean = false;
    translateService = inject(TranslateService);

    agInit(params: ICellRendererParams): void {
        this.refresh(params);
    }

    refresh(params: ICellRendererParams): boolean {
        this.tooltip.set(params.value ? params.value : 'Unknown');
        switch (params.value) {
            case BrokerAssociationStatus.ASSOCIABLE:
                this.value.set('lock');
                this.isRed = true;
                break;
            case BrokerAssociationStatus.VALIDATED:
                this.value.set('lock');
                this.isRed = false;
                break;
            case BrokerAssociationStatus.ARCHIVED:
                this.value.set('album');
                this.isRed = false;
                break;
            case BrokerAssociationStatus.MODIFIED:
                this.value.set('edit');
                this.isRed = false;
                break;
            case BrokerAssociationStatus.DEFAULT:
            default:
                this.value.set(undefined);
                this.isRed = false;
                break;
        }
        return true;
    }

}
